// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3aOUe","col":"styles_col__oJ7hR"};